<template>
  <div>
    <b-navbar>
      <b-navbar-brand
        class="text-black font-weight-bold"
        v-if="title"
        href="javascript:void()"
        >{{ title }}</b-navbar-brand
      >
      <b-navbar-nav class="ml-auto">
        <b-modal
          title="Select Date"
          header-class="header-nipige-class"
          id="dateRange"
          size="sm"
          ref="date-range"
          centered
          hide-footer
        >
          <b-input class="mb-2" type="date" v-model="startDate"></b-input>
          <span class="validate-error" v-if="startDate && !validStartDate"
            >Start Date is not valid</span
          >
          <b-input type="date" v-model="endDate"></b-input>
          <span class="validate-error" v-if="endDate && !validEndDate"
            >End Date is not valid</span
          >
          <div class="text-center mt-2">
            <b-button
              @click="findButtonClick()"
              class="my -0 main-navigation-button w-47 mr-2"
              variant="success"
              :disabled="!validStartDate || !validEndDate"
              >Find
            </b-button>
          </div>
        </b-modal>
        <b-nav-form>
          <b-form-select
            v-if="hasDropdown"
            class="mr-2"
            id="type"
            :options="hasfilterOptions"
            :selected="computedSelectedOption"
            v-model="computedSelectedOption"
            @change="selectedOptionValue"
          ></b-form-select>
          <b-input-group-append
            size="md"
            class="mb-2 mt-2 mr-2"
            v-if="hasSearch"
          >
            <b-form-input
              size="sm"
              :class="
                hasSearch && this.$route.fullPath == '/permission'
                  ? 'custom-width mr-sm-4 height'
                  : 'mr-sm-4 height'
              "
              placeholder="Search here"
              v-model="searchQuery"
              style="width: calc(100% + 280px)"
            ></b-form-input>
            <b-img
              v-if="searchQuery != '' && !enableOnClickSearch"
              :src="`img/search_cross.png`"
              @click="searchQuery = ''"
              class="image-size"
            ></b-img>
            <b-img
              v-else
              :src="`img/search.png`"
              class="image-size"
              @click="initSearch"
            ></b-img>
          </b-input-group-append>

          <!-- <b-button
            v-if="hasSearch && this.$route.fullPath != '/partner'"
            size="sm"
            variant="success"
            class="my-2 mr-2 my-sm-0"
            @click="searchQuery = ''"
            >Clear</b-button
          > -->
          <eb-select
            v-if="hasRadio"
            type="select"
            v-model="radioInput"
            :selected="radioInput.text"
            :options="radioOptions"
            label="text"
            id="value"
            size="md"
            class="select date-filter"
            :disabled="disableKey"
            placeholder="Select Date Filter"
            @input="radioChangeInput"
          ></eb-select>
          <b-button
            v-if="hasRequestList"
            size="sm"
            variant="info"
            class="my-2 ml-2 my-sm-0"
            @click="requestList"
            >{{ requestListButtonText }}</b-button
          >
          <b-button
            v-if="hasUnbilliedInvoice"
            size="sm"
            variant="info"
            class="my-2 ml-2 my-sm-0"
            @click="unbilliedInvoice"
            >{{ unbilliedInvoiceText }}</b-button
          >
          <b-button
            v-if="hasCreate"
            size="sm"
            :variant="createButtonType"
            class="my-2 ml-2 my-sm-0"
            @click="create"
            >{{ createButtonText }}</b-button
          >
          <b-button
            v-if="hasReload"
            size="sm"
            class="btn-primary ml-2"
            @click="reloadData"
            :disabled="isLoading"
          >
            <span
              v-if="isLoading"
              class="fa fa-refresh fa-spin"
              style="font-size: 15px"
            />
            <span v-else class="fa fa-refresh" style="font-size: 15px" />
          </b-button>
          <b-button
            v-if="hasExport"
            size="sm"
            :variant="exportButtonType"
            :class="
              hasExport && this.$route.fullPath == '/commission'
                ? 'my-2 mr-3 ml-3 my-sm-0'
                : 'my-2 ml-2 my-sm-0'
            "
            @click="exportData"
            >{{ exportButtonText }}</b-button
          >
          <b-button
            v-if="hasback"
            size="sm"
            :variant="backButtonType"
            class="my-2 ml-2 my-sm-0 btn-primary"
            @click="back"
            >{{ backButtonText }}</b-button
          >
        </b-nav-form>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import moment from "moment";
export default {
  components: {
    ebSelect,
  },
  data() {
    return {
      searchQuery: "",
      radioInput: {
        text: "Today",
        value: 1,
      },
      startDate: "",
      // selectedOption: "SELLER",
      computedSelectedOption: "",
      endDate: "",
    };
  },
  props: {
    hasfilterOptions: {
      type: Array,
      default: () => {
        [];
      },
    },
    enableOnClickSearch: {
      type: Boolean,
      default: false,
    },
    hasRadio: {
      type: Boolean,
      default: false,
    },
    disableKey: {
      type: Boolean,
      default: false,
    },
    selectedOption: {
      type: [String, Object],
    },
    radioOptions: {
      type: Array,
      default: () => {
        [];
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hasSearch: {
      type: Boolean,
      default: true,
    },
    hasOption: {
      type: Boolean,
      default: false,
    },
    hasCreate: {
      type: Boolean,
      default: true,
    },
    hasback: {
      type: Boolean,
      default: false,
    },
    hasExport: {
      type: Boolean,
      default: false,
    },
    hasSelect: {
      type: Boolean,
      default: true,
    },
    hasDropdown: {
      type: Boolean,
      default: false,
    },
    hasReload: {
      type: Boolean,
      default: true,
    },
    cleanSearchOnReload: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    createButtonText: {
      type: String,
      default: "Create",
    },
    backButtonText: {
      type: String,
      default: "Back",
    },
    exportButtonText: {
      type: String,
      default: "Export",
    },
    createButtonType: {
      type: String,
      default: "success",
    },
    backButtonType: {
      type: String,
      default: "btn-primary",
    },
    exportButtonType: {
      type: String,
      default: "success",
    },
    hasRequestList: { // New prop for Request List button
      type: Boolean,
      default: false,
    },
    requestListButtonText: { // New prop for Request List button text
      type: String,
      default: "Request List",
    },
    hasUnbilliedInvoice: {
      type: Boolean,
      default: false,
    },
    unbilliedInvoiceText: {
      type: String,
      default: "Unbillied Invoice",
    },
  },
  computed: {
    validStartDate() {
      if (!this.startDate) return false;
      if (moment().diff(this.startDate, "hour") <= 0) return false;
      return true;
    },
    validEndDate() {
      if (!this.endDate) return false;
      if (moment().diff(this.endDate, "hour") <= 0) return false;
      if (moment(this.endDate).diff(this.startDate, "day") <= 0) return false;
      return true;
    },
    // computedSelectedOption() {
    //   return this.selectedOption;
    // },
  },
  methods: {
    selectedOptionValue(e) {
      this.$emit("select-query", e);
    },
    initSearch() {
      if (this.enableOnClickSearch && this.searchQuery.length) {
        this.$emit("onClickSearch", this.searchQuery);
      }
    },
    resetSearchString() {
      this.searchQuery = "";
    },
    findButtonClick() {
      let e = {
        fromDate: this.startDate,
        toDate: this.endDate,
      };
      this.$emit("dateRangeEmit", e);
      this.startDate = null;
      this.endDate = null;
      this.$refs["date-range"].hide();
    },
    radioChangeInput() {
      let e = this.radioInput;
      if (e.value == "custom") {
        this.$refs["date-range"].show();
        this.startDate = null;
        this.endDate = null;
      } else {
        this.$emit("radioChangeInputEmit", e.value);
      }
    },
    create: function () {
      this.$emit("create-press");
    },
    back: function () {
      this.$emit("back-press");
    },
    requestList() { // New method for Request List button
      this.$emit("request-list-press");
    },
    unbilliedInvoice() {
      this.$emit("unbillied-invoice-press");
    },
    exportData() {
      this.$emit("onExport");
    },
    clearSearch: function () {
      this.searchQuery = "";
    },
    reloadData: function () {
      if (this.cleanSearchOnReload) {
        this.clearSearch();
      }
      this.$emit("reload-data");
    },
  },
  watch: {
    searchQuery() {
      this.$emit("search-query", this.searchQuery);
    },
    selectedOption() {
      this.computedSelectedOption = this.selectedOption;
    },
  },
  mounted() {
    this.computedSelectedOption = this.selectedOption;
  },
};
</script>

<style>
.header-nipige-class {
  background-color: var(--secondary);
  border-radius: 10px 10px 0px 0px;
}
.modal-title {
  font-size: 15px;
  color: white;
  text-align: center;
  margin-left: 40%;
}
.modal-content {
  border-radius: 10px 10px 10px 10px;
}
.height {
  height: 34.5px !important;
  border-radius: 20px;
  padding-right: 27px;
}
.margin-right {
  margin-right: 30px;
}
.image-size {
  height: 16px;
  width: 16px;
  margin-top: 7px;
  cursor: pointer;
  margin-left: -57px;
}
.date-filter {
  margin-left: 2rem;
  margin-right: 0.5rem;
}
.date-filter .vs__selected-options {
  padding: 1px 3px !important;
  width: 12rem !important;
}
input[type="date"]:after {
  content: attr(placeholder);
}
.custom-width {
  width: 300px !important;
}
</style>
